import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { Link,useNavigate } from "react-router-dom";
import MediaMainBG from "../component/MediaMainBG/MediaMainBG.js";
import PreviewImage from "../component/previews/PreviewImage.js";
import { useGetVideosByApiQuery } from "../services/modulesuser/videoListApi/index.js";

import { META_TITLE_END } from "../services/lib/metaTags.js";
import { useDispatch,useSelector } from "react-redux";

import Previews from "../component/previews/Previews.js";
import Heading from "../component/ui/Heading.js";
import { setFavorites } from "../store/user";

function Favorite() {
  const dispatch = useDispatch();
  const { name,avatar,watchlistMovies,favorites } = useSelector(state => state.user);

  return (
    <>
      {/* Meta data */}
      {/* <Helmet>
        <title>{`${name}'s Profile${META_TITLE_END}`}</title>
        <meta
          name="description"
          content="View and modify your profile information, including your personalized watch and like lists. Manage your preferences and keep track of your favorite movies, shows, and people"
        />
        <meta name="robots" content="index,follow" />
      </Helmet> */}

      <div className="flex flex-col gap-6">
        <div>
          <Heading as="h3">Preferiti</Heading>
          <MediaMainBG type="Favoriti" />
          {Array.isArray(favorites) && favorites.length > 0 ? (
<div className="flex flex-wrap gap-6 justify-start content-start">
              {favorites.map((video) => (
                <div
                  key={video.id}
                  style={{ flexBasis: 300 }}
              className="block flex-shrink-0 rounded-lg overflow-x-hidden max-w-[350px] w-full"
                >
                  <Link
                    to={`/videos/${video.id}`}
                    state={{ video: video }}
                    className="block"
                    style={{ height: 200 }}
                  >
                    <PreviewImage media={video} type={'tv'} hud={true} />
                  </Link>
                </div>
              ))}
            </div>) : (
            <p>La tua lista di "Preferiti" è vuota. Puoi andare alla nostra sezione <Link to={`/`}>"Home page"</Link> e iniziare a riempirla.</p>

          )}
        </div>
      </div>
    </>
  );
}

export default Favorite;


